export var uiArrowRight = [
    'M7.82 2.86L7.65 3.02C7.53 3.14 7.53 3.3 7.65 3.42L11.82 7.59H3.03C2.87 7.59 2.75 7.73 2.75 7.87V8.11C2.75 8.27 2.87 8.39 3.03 8.39H11.82L7.65 12.58C7.53 12.7 7.53 12.86 7.65 12.98L7.82 13.14C7.93 13.26 8.1 13.26 8.21 13.14L13.16 8.2C13.28 8.08 13.28 7.92 13.16 7.8L8.21 2.86C8.1 2.74 7.93 2.74 7.82 2.86Z',
];
